import compose from 'recompose/compose';

import { mapThemeChangesToStorageSaves } from './theme';

export default compose(mapThemeChangesToStorageSaves);
